import { bootstrapPowerClerk } from "_Main/setupAnonEntrypoint";
import login from "./login.vue";
bootstrapPowerClerk(login);
